export default {
  plano: null,
  cliente: null,
  fatura: null,
}
